<template>
  <div class="full-page-width view-shipment">
    <div class="add-button c-float m-b-25">
      <div class="flex-center float-left">
        <Btn
          @click.native="routeIt"
          class="light bordered empty d-inline-block m-r-15 fix-40"
          :icon="{
            name: 'arrowLeftBig',
            size: '20',
          }" />
        <p class="user-name" v-if="get_single_shipment !== null">{{ `${$t('shipment')} #${get_single_shipment.trace_no}` }}</p>
      </div>
      <Dropdown
        v-if="get_single_shipment && !get_single_shipment.is_shared_shipment"
        class="float-right drop-right"
        :buttonText="$t('Actions')"
        :dropdownOptions="availableDropdownOptions"
        @optionSelected="optionSelected" />
    </div>
    <!-- TOP BAR -->
    <div v-if="get_single_shipment !== null">
      <div class="shipment-info-box card no-pad m-b-40">
        <div class="map-holder">
          <GmapMap
            ref="mapRef"
            :center="center"
            :path="path"
            :zoom="10"
            :options="{
              zoomControl: false,
              mapTypeControl: false,
              scaleControl: false,
              streetViewControl: false,
              rotateControl: false,
              fullscreenControl: true,
              disableDefaultUi: false
            }"
            style="width: 100%; height: 500px">
            <GmapMarker
              :key="index"
              v-for="(m, index) in markers.reverse()"
              :label="{text: markerLabels[index++ % markerLabels.length]}"
              :position="m"
              :clickable="false"
              :draggable="false"
              @click="center=m.position"
            />
          </GmapMap>
        </div>
        <div class="top-row flex">
          <div class="info-box fix-width-position">
            <p class="small-text">{{ formatDate(get_single_shipment.ship_date, 'shipment') }}</p>
            <p class="big-text">
              <span class="cut-text medium">{{ get_single_shipment.sender_city }}</span>
              <span class="align-middle">{{ `, ${get_single_shipment.sender_country_alpha2}` }}</span>
            </p>
            <p class="small-text tooltip-holder">
              <span class="cut-text small">{{ get_single_shipment.sender_company_name ||  get_single_shipment.sender_name}}</span>
              <span class="d-inline-block info-tooltip">
                <Icon
                  v-tooltip="{ ref: 'tooltipRef'}"
                  name="info"
                  size="15" />
                <div class="info-tooltip-window" ref="tooltipRef">
                  <p v-if="get_single_shipment.sender_company_name">{{ get_single_shipment.sender_company_name }}</p>
                  <p v-if="get_single_shipment.sender_name">{{ get_single_shipment.sender_name }}</p>
                  <p v-if="get_single_shipment.sender_address_1">{{ get_single_shipment.sender_address_1 }}</p>
                  <p v-if="get_single_shipment.sender_address_2">{{ get_single_shipment.sender_address_2 }}</p>
                  <p v-if="get_single_shipment.sender_post_code || get_single_shipment.sender_city">{{ `${get_single_shipment.sender_post_code} ${get_single_shipment.sender_city}` }}</p>
                  <p v-if="get_single_shipment.sender_state">{{ get_single_shipment.sender_state }}</p>
                  <p v-if="get_single_shipment.sender_country_id">{{ countryName(get_single_shipment.sender_country_id) }}</p>
                  <p v-if="get_single_shipment.sender_phone">{{ `${get_single_shipment.sender_phone}` }}</p>
                  <p v-if="get_single_shipment.sender_email">{{ get_single_shipment.sender_email }}</p>
                </div>
              </span>
            </p>
          </div>
          <div class="middle-box status-box" v-if="get_single_shipment != null">
            <div
              class="shipment-status-bar"
              :class="statusInfo(get_single_shipment.status).class">
              <svg class="stroke-dashed" xmlns="http://www.w3.org/2000/svg">
                <line x1="0" y1="0" x2="100%" y2="0" />
              </svg>
              <div class="icon-point">
                <p class="status-text">{{ $t(statusInfo(get_single_shipment.status).text) }}</p>
                <Icon
                  :name="statusInfo(get_single_shipment.status).icon"
                  size="15" />
              </div>
              <div class="point-one"></div>
              <div class="point-two"></div>
            </div>
            <p class="update-info">
              {{ `${$t('last_update')}` }} <span style="text-transform: lowercase">{{ `${formatDate(get_single_shipment.shipment_status_date, 'shipment_last_update')}` }} </span> |
              {{ getStatusMessageText(get_single_shipment.shipment_status_message, '#', 0) }}
            </p>
          </div>
          <div class="info-box fix-width-position">
            <div class="date-section">
              <p class="small-text date-display">
              <span :class="{ 'strikethrough': get_single_shipment.actual_eta }"> {{ formatDate(get_single_shipment.eta, 'shipment') }} </span>
                <span v-if="get_single_shipment.actual_eta">
               <span class="date-arrow"> > </span>
               <span class="actual-eta">{{ formatDate(get_single_shipment.actual_eta, 'shipment') }}</span>
              </span>
              </p>
            </div>
            <p class="big-text">
              <span class="cut-text medium">{{ get_single_shipment.customer_address_city }}</span>
              <span class="align-middle">{{ `, ${get_single_shipment.customer_address_country_alpha2}` }}</span>
            </p>
            <p class="small-text tooltip-holder">
              <span class="cut-text small">{{ get_single_shipment.customer_address_company_name ||  get_single_shipment.customer_address_name}}</span>
              <span class="d-inline-block info-tooltip">
                <Icon
                  v-tooltip="{ ref: 'tooltipRefCustomer'}"
                  name="info"
                  size="15" />
                <div class="info-tooltip-window" ref="tooltipRefCustomer">
                  <p v-if="get_single_shipment.customer_address_company_name">{{ get_single_shipment.customer_address_company_name }}</p>
                  <p v-if="get_single_shipment.customer_address_name">{{ get_single_shipment.customer_address_name }}</p>
                  <p v-if="get_single_shipment.customer_address_address_1">{{ get_single_shipment.customer_address_address_1 }}</p>
                  <p v-if="get_single_shipment.customer_address_address_2">{{ get_single_shipment.customer_address_address_2 }}</p>
                  <p v-if="get_single_shipment.customer_address_post_code || get_single_shipment.customer_address_city">{{ `${get_single_shipment.customer_address_post_code} ${get_single_shipment.customer_address_city}` }}</p>
                  <p v-if="get_single_shipment.customer_address_state">{{ get_single_shipment.customer_address_state }}</p>
                  <p v-if="get_single_shipment.customer_address_country_id">{{ countryName(get_single_shipment.customer_address_country_id) }}</p>
                  <p v-if="get_single_shipment.customer_address_phone">{{ `${get_single_shipment.customer_address_phone}` }}</p>
                  <p v-if="get_single_shipment.customer_address_email">{{ get_single_shipment.customer_address_email }}</p>
                </div>
              </span>
            </p>
          </div>
        </div>
        <div class="separator medium"></div>
        <div class="bottom-row flex">
          <div class="info-box c-float w-33">
            <LogosSVG :name="get_single_shipment.shipping_agent_name" size="45" class="float-left m-r-15" />
            <div class="float-left">
              <div v-if="!get_single_shipment.internal_tracking_link && !get_single_shipment.tracking_link">
                <p class="big-info-text">
                  <span class="m-r-5">{{ get_single_shipment.trace_no }}</span>
                </p>
              </div>
              <div v-else>
                <p class="big-info-text pointer shipment-tracking-link"
                   @click.stop="linkCall(get_single_shipment.internal_tracking_link ? get_single_shipment.internal_tracking_link : get_single_shipment.tracking_link)">
                  <span class="m-r-5 color-brend">{{ get_single_shipment.trace_no }}</span>
                  <Icon
                    class="d-inline-block align-middle color-brand"
                    name="link"
                    size="14" />
                </p>
              </div>
              <div>
                <p class="small-text tooltip-holder">
                  <span class="cut-text small">{{get_single_shipment.shipping_agent_name}}</span>
                  <span class="d-inline-block info-tooltip">
                <Icon
                  v-tooltip="{ ref: 'tooltipCustomerService'}"
                  name="info"
                  size="15" />
                <div class="info-tooltip-window" ref="tooltipCustomerService">
                  <p>{{ `${$t('customer_service')}` }}</p>
                  <p>{{ get_single_shipment.agent.email }}</p>
                  <p>{{ get_single_shipment.agent.phone }}</p>
                </div>
                </span>
                </p>
              </div>
            </div>
          </div>
          <div class="middle-box c-float w-33">
            <Icon
              :circle=true
              name="hashMark"
              size="17"
              class="float-left m-r-15" />
            <div class="float-left">
              <p class="big-info-text">{{ `${$t('Sender ref.:')} ${get_single_shipment.sender_reference || '-'}` }}</p>
              <p class="small-info-text">{{ `${$t('Receiver ref.:')} ${get_single_shipment.receiver_reference || '-'}` }}</p>
            </div>
          </div>
          <div class="info-box c-float fix-width-position w-33 max-w-225">
            <Icon
              :circle=true
              :name="goodTypeName(get_single_shipment.goods_type_prioritized).icon"
              size="20"
              class="float-left m-r-15" />
            <div class="float-left">
              <p class="big-info-text">{{ get_single_shipment.shipping_product_name }}</p>
              <p class="small-info-text">{{ getShipmentGoodsTypeText(get_single_shipment) }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- LEFT PART - PRODUCTS -->
    <div class="row text-box">
      <div class="col-xs-8" v-if="get_single_shipment != null">
        <!-- DOCUMENTS -->
        <div class="m-b-40" v-if="get_single_shipment.file">
          <h2 class="m-b-20 section-title">{{ $t('documents') }}</h2>
          <div class="package-preview card-boxed">
            <div class="flex-boxed center">
              <!-- 1. Waybill -->
              <div class="info-box inf-abs c-float">
                <Icon
                  :circle=true
                  name="barcode"
                  size="20"
                  class="icon-left m-r-15" />
                <div class="float-left">
                  <p class="big-info-text">{{ $t('Waybills') }}</p>
                  <p class="small-info-text link pointer" @click="downloadWaybill">
                    {{ $t('download') }}
                  </p>
                  <a
                    style="display: none"
                    :download="`Waybill_${get_single_shipment.id}`"
                    ref="downloadWaybillPDF"
                    :href="waybillPdfPath" />
                </div>
              </div>
              <!-- 2. EOD -->
              <div class="info-box inf-abs c-float" v-if="get_single_shipment.batch_number != null">
                <Icon
                  :circle=true
                  name="agreements"
                  size="20"
                  class="icon-left m-r-15" />
                <div class="float-left">
                  <p class="big-info-text">{{ $t('eod_manifest') }}</p>
                  <p class="small-info-text link pointer" @click="downloadEOD">
                    {{ $t('download') }}
                  </p>
                </div>
              </div>
              <a
                style="display: none"
                :download="`${downloadEodName}`"
                ref="downloadEODPDF"
                :href="eodPdfPath" />
              <!-- 3. POD -->
              <div class="info-box inf-abs c-float" v-if="shouldShowDownloadSignatureLink">
                <Icon
                  :circle=true
                  name="edit"
                  size="20"
                  class="icon-left m-r-15" />
                <div class="float-left">
                  <p class="big-info-text">{{ $t('POD signature') }}</p>
                  <p class="small-info-text link pointer" @click="downloadPOD">
                    {{ $t('download') }}
                  </p>
                  <a
                    style="display: none"
                    :download="`Signature_images_${get_single_shipment.id}`"
                    ref="downloadPODref"
                    :href="podPath" />
                </div>
              </div>
              <!-- 4. POD images -->
              <div class="info-box inf-abs c-float" v-if="get_single_shipment.scan_image_paths != null && get_single_shipment.scan_image_paths != ''">
                <Icon
                  :circle=true
                  name="images"
                  size="20"
                  class="icon-left m-r-15" />
                <div class="float-left">
                  <p class="big-info-text">{{ $t('POD images') }}</p>
                  <p class="small-info-text link pointer" @click="downloadScanImage">
                    {{ $t('download') }}
                  </p>
                  <a
                    style="display: none"
                    :download="`POD_images_${get_single_shipment.id}`"
                    ref="downloadScanImage"
                    :href="scanImagePath" />
                </div>
              </div>
              <!-- 5. Commercial invoice -->
              <div class="info-box inf-abs c-float" v-if="get_single_shipment.customs_file != null">
                <Icon
                  :circle=true
                  name="agreements"
                  size="20"
                  class="icon-left m-r-15" />
                <div class="float-left">
                  <p class="big-info-text">{{ customsFileLabel }}</p>
                  <p class="small-info-text link pointer" @click="downloadInvoice">
                    {{ $t('download') }}
                  </p>
                  <a
                    style="display: none"
                    :download="`Invoice_${get_single_shipment.id}`"
                    ref="downloadInvoicePDF"
                    :href="invoicePdfPath" />
                </div>
              </div>
              <!-- 6. dg -->
              <div class="info-box inf-abs c-float" v-if="get_single_shipment.dg_file != null">
                <Icon
                  :circle=true
                  name="agreements"
                  size="20"
                  class="icon-left m-r-15" />
                <div class="float-left">
                  <p class="big-info-text">{{ $t('dangerous_goods') }}</p>
                  <p class="small-info-text link pointer" @click="downloadDGFile">
                    {{ $t('download') }}
                  </p>
                  <a
                    style="display: none"
                    :download="`dg_${get_single_shipment.id}`"
                    ref="downloadDgRef"
                    :href="dangerousGoodsPdfPath" />
                </div>
              </div>
              <!-- 7. Additional files -->
              <div
                v-for="(file, index) in get_single_shipment.additional_files"
                :key="`${index}-file`"
                class="info-box inf-abs c-float">
                <Icon
                  :circle=true
                  name="attach"
                  size="20"
                  class="icon-left m-r-15"/>
                <div class="float-left">
                  <p class="big-info-text">{{ get_additional_file_types[index] }}</p>
                  <p class="small-info-text link pointer" @click="downloadAdditionalFile(index)">
                    {{ file.file_name }}
                  </p>
                  <a
                    style="display: none"
                    :download="`${file.file_name}`"
                    :ref="`downloadAdditionalFile${index}`"
                    :href="additionalFilePdfPath[index]"/>
                </div>
              </div>

              <div
                v-for="(file, index) in get_single_shipment.shipment_files"
                :key="`shipment-file-${index}`"
                class="info-box inf-abs c-float">
                <Icon
                  :circle=true
                  :name="getFileTypeIcon(file.file_type)"
                  size="20"
                  class="icon-left m-r-15" />
                <div class="float-left">
                  <p class="big-info-text">{{ getFileTypeLabel(file.file_type) }}</p>
                  <p class="small-info-text link pointer" @click="downloadShipmentFile(file)">
                    {{ $t('download') }}
                  </p>
                  <a
                  style="display: none"
                  :download="file.original_filename || `${file.file_type}_${get_single_shipment.id}`"
                  :ref="`downloadShipmentFile${file.id}`"
                  :href="shipmentFilePaths[file.id]" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- GOODS INFO -->
        <div v-if="get_single_shipment.use_content_on_shipment_level" class="m-b-40">
          <div>
            <template>
              <h2 class="m-b-20 section-title">{{ $t('goods_in_your_shipment' )}}</h2>
            </template>
            <div class="card">
              <div v-if="shipmentContentGroup.content.length">
                <div
                  v-for="(content, index) in shipmentContentGroup.content" :key="`content-${index}`"
                  class="content-item flex center top"
                  :class="index + 1 < shipmentContentGroup.content.length ? 'm-b-15' : ''">
                  <div>
                    <p class="big-info-text">{{ content.description }}</p>
                    <p class="small-info-text" v-if="content.hs_code && content.origin_country_id">
                      {{
                        `${$t('HS code')}: ${content.hs_code} - ${$t('Origin')}: ${getCountry(content.origin_country_id, 'name')} (${content.origin_country_alpha2})`
                      }}
                    </p>
                  </div>
                  <div class="big-info-text">
                    {{ `${content.quantity}  x ` }}
                    {{ content.unit_value | forNum }} {{
                      content.unit_value_currency.toUpperCase()
                    }}
                  </div>
                  <div class="big-info-text">
                    {{ content.quantity * content.unit_value | forNum }}
                    {{ content.unit_value_currency.toUpperCase() }}
                  </div>
                </div>
              </div>
              <div v-else>
                <div
                  class="content-item flex center top">
                  <div>
                    <p class="big-info-text">{{ get_single_shipment.description }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- PACKAGES -->
        <div>
          <div
            v-for="(group, index) in get_single_shipment.package_groups" :key="`package-group-${index}`">
            <template>
              <h2 class="m-b-20 section-title">{{ `${group.packages_count} x ${goodTypeName(group.package.goods_type, group.packages_count > 1).name.toLowerCase()}` }}</h2>
            </template>
            <div
              :class="index + 1 < get_single_shipment.packages.length ? 'm-b-40' : ''"
              class="package-preview card m-b-40">

              <!-- MAIN INFO -->
              <div class="flex center" style="align-items: start;">
                <!-- Package name -->
                <div
                  :class="group.package.services.length > 0 || group.package.has_temperature ? '' : 'w-50'"
                  class="info-box c-float">
                  <Icon
                    :circle=true
                    :name="goodTypeName(group.package.goods_type).icon"
                    size="20"
                    class="float-left m-r-15" />
                  <div class="float-left">
                    <p class="big-info-text">{{ $t(group.package.packaging_name) }}</p>
                    <p class="small-info-text">
                      {{ `${group.package.length} x ${group.package.width} x ${group.package.height} cm (${getVolumeText(group.package.vol_dm3)}` }}
                      <span style="vertical-align: super;
                        font-size: 10px;
                        line-height: 0px;">3</span>
                      )
                    </p>
                  </div>
                </div>
                <!-- Package weight -->
                <div
                  :class="group.package.services.length > 0 || group.package.has_temperature ? '' : 'w-50'"
                  class="info-box c-float">
                  <Icon
                    :circle=true
                    name="scale"
                    size="20"
                    class="float-left m-r-15" />
                  <div class="float-left">
                    <p class="big-info-text">{{ group.package.weight | weight }}</p>
                    <p class="small-info-text">Volume {{ group.package.volume_in_kg | weight }}</p>
                  </div>
                </div>
                <!-- Package dangerous goods -->
                <div class="info-box c-float" v-if="group.dangerous_goods && group.dangerous_goods.length > 0">
                  <Icon
                    :circle=true
                    name="energy"
                    size="20"
                    class="float-left m-r-15" />
                  <div class="float-left">
                    <p class="big-info-text">Dangerous goods</p>
                    <div v-for="(groupDg, index) in group.dangerous_goods" :key="`dg-service-${index}`">
                      <p class="small-info-text cut-text extra-small">{{ `${groupDg.dangerous_goods.shipment_view_name}` }}</p>
                    </div>
                  </div>
                </div>
                <!-- Package temperature -->
                <div class="info-box c-float" v-if="group.package.has_temperature">
                  <Icon
                    :circle=true
                    name="temperature"
                    size="20"
                    class="float-left m-r-15" />
                  <div class="float-left">
                    <p class="big-info-text">{{ $t('Temperature controlled') }}</p>
                    <p class="small-info-text">{{ `${group.package.min_temp} ${$t('to')} ${group.package.max_temp}` }} C&deg;</p>
                  </div>
                </div>
              </div>
              <div class="separator"></div>
              <!-- CONTENT INFO -->
              <div v-if="!get_single_shipment.use_content_on_shipment_level">
                <h2 class="m-b-20 f-s-16 f-w-500">{{ `${group.packages_count > 1 ? $t('these') : $t('this')} ${$i18n.t('packages_contain_following_goods', {
                  packages_count: group.packages_count > 1 ? group.packages_count : '',
                  goods_type: goodTypeName(group.package.goods_type, group.packages_count > 1).name.toLowerCase(),
                })}` }}</h2>
                <div v-if="group.content.length">
                  <div
                       class="content-item flex center top"
                       :class="index + 1 < group.content.length ? 'm-b-15' : ''"
                       v-for="(content, index) in group.content" :key="`content-${index}`">
                    <div>
                      <p class="big-info-text">{{ content.description }}</p>
                      <p class="small-info-text" v-if="content.hs_code && content.origin_country_id">
                        {{ `${$t('HS code')}: ${content.hs_code} - ${$t('Origin')}: ${getCountry(content.origin_country_id, 'name')} (${content.origin_country_alpha2})` }}
                      </p>
                    </div>
                    <div class="big-info-text">
                      {{`${content.quantity}  x `}}
                      {{ content.unit_value | forNum }} {{ content.unit_value_currency.toUpperCase() }}
                    </div>
                    <div class="big-info-text">
                      {{ content.quantity * content.unit_value | forNum }} {{ content.unit_value_currency.toUpperCase() }}
                    </div>
                  </div>
                </div>
                <div v-else>
                  <div
                    class="content-item flex center top">
                    <div>
                      <p class="big-info-text">{{ group.package.description }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="!get_single_shipment.use_content_on_shipment_level" class="separator"></div>
              <div class="no-overflow">
                <h2 class="m-b-20 f-s-16 f-w-500">{{ $t('colli_numbers') }}</h2>
                <div v-for="(pack, packageIndex) in group.packages" :key="`package-${packageIndex}`">
                  <div :class="colliNumberClasses(group)">
                    <p class="big-info-text pointer shipment-tracking-link"
                       @click.stop="linkCall(getPackageTrackingLink(get_single_shipment.raw_tracking_link, pack.package_trace_no, get_single_shipment.id, get_single_shipment.uuid))">
                      <span class="m-r-5 color-brend">{{ pack.package_trace_no }}</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- FINANCE -->
        <div
          v-if="!get_single_shipment.is_shared_shipment
                && get_user.should_show_freight_prices
                && get_active_subaccount.is_visible_freight_prices" >
          <h2 class="m-b-20 section-title">{{ $t('Finance') }}</h2>
          <div class="card">
            <div v-for="[awb, financeGroup] in financeGrouped" :key="`${awb}-finance`">
              <p class="finance-header-text" v-if="shipmentIsCalculatedByColli">{{ `AWB - ${awb}` }}</p>
              <div class="finance-card">
                <div class="finance-index">
                  <p class="f-col-1">{{ $t('Booked') }}</p>
                  <p class="f-col-2">{{ $t('invoiced') }}</p>
                  <p v-if="get_is_ship365" class="f-col-3">{{ $t('Invoice controle') }}</p>
                </div>
                <div class="finance-row">
                  <div class="info-box c-float f-col-1">
                    <Icon
                      :circle=true
                      name="scale"
                      size="20"
                      class="float-left m-r-15"/>
                    <div class="float-left">
                      <p class="big-info-text">{{ getFinanceBillingWeight(awb) | weight }}</p>
                      <p class="small-info-text">{{ $t('Bill weight') }}</p>
                    </div>
                  </div>
                  <div class="info-box c-float f-col-2">
                    <div class="float-right">
                      <p class="big-info-text" v-if="get_single_shipment.vi_invoiced_weight">{{ parseFloat(get_single_shipment.vi_invoiced_weight ? get_single_shipment.vi_invoiced_weight : 0) | weight }}</p>
                      <p class="big-info-text" v-else>-</p>
                      <p v-if="get_single_shipment.vi_invoiced_weight" :class="['small-info-text', resolveClassByAmount(get_single_shipment.vi_invoiced_weight - getFinanceBillingWeight(awb))]">{{ (get_single_shipment.vi_invoiced_weight - getFinanceBillingWeight(awb)) | weight  }}</p>
                      <p class="small-info-text" v-else>-</p>
                    </div>
                  </div>
                  <div v-if="get_is_ship365" class="info-box c-float f-col-3">
                    <div class="float-right">
                      <p class="big-info-text">-</p>
                      <p class="small-info-text">-</p>
                    </div>
                  </div>
                </div>
                <div class="finance-row" v-for="(item, itemIndex) in financeGroup" :key="`${itemIndex}-colli`">
                  <div class="info-box c-float f-col-1">
                    <Icon
                      :circle=true
                      :name="iconType(item.type)"
                      size="20"
                      class="float-left m-r-15"/>
                    <div class="float-left">
                      <p class="big-info-text">{{ item.booked_price | currency(get_single_shipment.currency_conversion) }}</p>
                      <p class="small-info-text" v-if="[5, 6].includes(item.type)" >{{`${$t(item.item_name)}`}}</p>
                      <p class="small-info-text" v-else>{{ $t(item.item_name) }}</p>
                    </div>
                  </div>
                  <div class="info-box c-float f-col-2">
                    <div class="float-right">
                      <p class="big-info-text" v-if="item.invoiced_price">{{ parseFloat(item.invoiced_price ? item.invoiced_price : 0) | currency(get_single_shipment.currency_conversion) }}</p>
                      <p class="big-info-text" v-else>-</p>
                      <p v-if="item.invoiced_price" :class="['small-info-text', resolveClassByAmount(parseFloat(item.invoiced_price - item.booked_price))]">{{ (item.invoiced_price - item.booked_price) | currency(get_single_shipment.currency_conversion) }}</p>
                      <p class="small-info-text" v-else>-</p>
                    </div>
                  </div>
                  <div v-if="get_is_ship365" class="info-box c-float f-col-3">
                    <div class="float-right">
                      <p class="big-info-text" v-if="item.invoiced_control">{{ parseFloat(item.invoiced_control ? item.invoiced_control : 0) | currency(get_single_shipment.currency_conversion) }}</p>
                      <p class="big-info-text" v-else >-</p>
                      <p v-if="item.invoiced_control" :class="['small-info-text', resolveClassByAmount(parseFloat(item.invoiced_price - item.invoiced_control))]">{{ (item.invoiced_price - item.invoiced_control) | currency(get_single_shipment.currency_conversion) }}</p>
                      <p class="small-info-text" v-else>-</p>
                    </div>
                  </div>
                </div>
                <div class="finance-row" v-if="showVat">
                  <div class="info-box c-float f-col-1">
                    <Icon
                      :circle=true
                      :name="iconType('vat')"
                      size="18"
                      class="float-left m-r-15"/>
                    <div class="float-left">
                      <p class="big-info-text">{{ vatAmountGrouped.get(awb) | currency(get_single_shipment.currency_conversion) }}</p>
                      <p class="small-info-text">{{ `${$t('VAT')} (${get_active_subaccount.vat_percent}%)` }}</p>
                    </div>
                  </div>
                  <div class="info-box c-float f-col-2">
                    <div class="float-right">
                      <p class="big-info-text">-</p>
                      <p class="small-info-text">-</p>
                    </div>
                  </div>
                  <div v-if="get_is_ship365" class="info-box c-float f-col-3">
                    <div class="float-right">
                      <p class="big-info-text">-</p>
                      <p class="small-info-text">-</p>
                    </div>
                  </div>
                </div>
                <div class="separator small"></div>
                <div class="finance-row">
                  <div class="info-box c-float f-col-1">
                    <Icon
                      :circle=true
                      :name="iconType('sum')"
                      size="28"
                      class="float-left m-r-15"/>
                    <div class="float-left">
                      <p class="big-info-text">{{ totalBookedAmountGrouped.get(awb) | currency(get_single_shipment.currency_conversion) }}</p>
                      <p class="small-info-text">{{ $t('total') }}</p>
                    </div>
                  </div>
                  <div class="info-box c-float f-col-2">
                    <div class="float-right">
                      <p v-if="totalInvoicedAmountGrouped.get(awb)" class="big-info-text">{{ totalInvoicedAmountGrouped.get(awb) | currency(get_single_shipment.currency_conversion)}}</p>
                      <p class="big-info-text" v-else >-</p>
                      <p v-if="totalInvoicedAmountGrouped.get(awb)" :class="['small-info-text', resolveClassByAmount(totalInvoicedAmountGrouped.get(awb) - totalBookedAmountGrouped.get(awb))]">{{ (totalInvoicedAmountGrouped.get(awb) - totalBookedAmountGrouped.get(awb)) | currency(get_single_shipment.currency_conversion) }}</p>
                      <p v-else class="small-info-text">-</p>
                    </div>
                  </div>
                  <div v-if="get_is_ship365" class="info-box c-float f-col-3">
                    <div class="float-right">
                      <p class="big-info-text" v-if="totalInvoicedControlGrouped.get(awb)">{{ totalInvoicedControlGrouped.get(awb) | currency(get_single_shipment.currency_conversion) }}</p>
                      <p class="big-info-text" v-else >-</p>
                      <p v-if="totalInvoicedControlGrouped.get(awb)" :class="['small-info-text', resolveClassByAmount(totalInvoicedAmountGrouped.get(awb) - totalInvoicedControlGrouped.get(awb))]">{{ (totalInvoicedAmountGrouped.get(awb) - totalInvoicedControlGrouped.get(awb)) | currency(get_single_shipment.currency_conversion)}}</p>
                      <p v-else class="small-info-text">-</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- DETAILS -->
      <div class="col-xs-4" v-if="get_single_shipment != null">
        <h2 class="m-b-20 section-title">{{ $t('details') }}</h2>
        <div class="card details-box m-b-40">
          <div class="info-box c-float" v-if="get_single_shipment.prg_number">
            <Icon
              :circle=true
              name="document"
              size="20"
              class="float-left m-r-15" />
            <div class="float-left">
              <p class="big-info-text">{{ $t('pickup_number' )}}</p>
              <p class="small-info-text">{{ get_single_shipment.prg_number }}</p>
            </div>
          </div>
          <div class="info-box c-float">
            <Icon
              :circle=true
              name="building"
              size="20"
              class="float-left m-r-15" />
            <div class="float-left">
              <p class="big-info-text">{{ $t('account') }}</p>
              <p class="small-info-text">{{ getAccountName }}</p>
            </div>
          </div>
          <div class="info-box c-float">
            <Icon
              :circle=true
              name="coins"
              size="20"
              class="float-left m-r-15" />
            <div class="float-left">
              <p class="big-info-text">{{ $t('freight_paid_by')}}</p>
              <p class="small-info-text">{{ $t(freightPaidByName) }}</p>
            </div>
          </div>
          <div class="info-box c-float">
            <Icon
              :circle=true
              name="document"
              size="20"
              class="float-left m-r-15" />
            <div class="float-left">
              <p class="big-info-text">{{ $t('Incoterms')}}</p>
              <p class="small-info-text">{{ get_single_shipment.goods_incoterm }}</p>
            </div>
          </div>
          <div
            class="info-box c-float"
            v-if="get_single_shipment.pickup_time_from && get_single_shipment.pickup_time_until && get_single_shipment.pickup_time_zone">
            <Icon
              :circle=true
              name="deliveryTime"
              size="20"
              class="float-left m-r-15" />
            <div class="float-left">
              <p class="big-info-text">
                {{ $t('pickup') }} {{ this.calculateGMTOffsetTimeDifference(get_single_shipment.pickup_time_from, get_single_shipment.pickup_time_zone) }} - {{ this.calculateGMTOffsetTimeDifference(get_single_shipment.pickup_time_until, get_single_shipment.pickup_time_zone) }}
              </p>
              <p class="small-info-text">{{ get_single_shipment.pickup_driver_note }}</p>
            </div>
          </div>
          <div v-if="get_single_shipment !== null">
            <div
              v-for="(item, index) in get_single_shipment.fees" :key="`item-${index}`"
              class="info-box c-float">
              <Icon
                :circle=true
                name="truck"
                size="20"
                class="float-left m-r-15" />
              <div class="float-left">
                <p class="big-info-text" >{{`${$t(item.name)}`}}</p>
                <p class="small-info-text" v-if="parseInt(item.wrapper_category) === 9">
                  {{ get_single_shipment.active_services_view[item.fee_wrapper_id].value }}
                  {{ get_single_shipment.active_services_view[item.fee_wrapper_id].currency }}
                </p>
                <p class="small-info-text" v-if="parseInt(item.wrapper_category) === 26">
                  {{ formatDate(get_single_shipment.active_services_view[item.fee_wrapper_id].date) }} -
                  {{ get_single_shipment.active_services_view[item.fee_wrapper_id].time }}
                </p>
                <p class="small-info-text" v-if="parseInt(item.wrapper_category) === 24">
                  {{ get_single_shipment.active_services_view[item.fee_wrapper_id].details }}
                </p>
                <p class="small-info-text" v-if="parseInt(item.wrapper_category) === 8">
                  {{ formatDate(get_single_shipment.active_services_view[item.fee_wrapper_id].date) }}
                </p>
                <p class="small-info-text" v-if="parseInt(item.wrapper_category) === 15">
                  {{ formatPallets() }}
                </p>
              </div>
            </div>
          </div>
          <div v-if="get_single_shipment !== null">
            <div
              v-for="(item, index) in get_single_shipment.custom_tags" :key="`item-${index}`"
              class="info-box c-float">
              <Icon
                :circle=true
                name="tag"
                size="20"
                class="float-left m-r-15" />
              <div class="float-left">
                <p class="big-info-text">{{ item.custom_tag_name }}</p>
                <p class="small-info-text" style="word-break: break-word;">{{ item.custom_tag_value }}</p>
              </div>
            </div>
          </div>
        </div>
        <!-- TIMELINE -->
        <h2 class="m-b-20 section-title">{{ $t('timeline') }}</h2>
        <div class="card details-box">
          <div v-if="get_single_shipment !== null" class="timeline-box">
            <svg class="stroke-dashed" xmlns="http://www.w3.org/2000/svg">
              <line x1="0px" y1="40px" x2="0px" y2="100%" />
            </svg>
            <div class="timeline-holder">
              <div
                v-for="(group, index) in timelineArray" :key="`group-${index}`"
                class="timeline-group">
                <div class="list-separator"><div></div></div>
                <h2 class="timeline-group-title">{{ index }}</h2>
                <div class="timeline-info">
                  <div v-for="(item, index) in group" :key="`groupItem-${index}`" class="info-box c-float">
                    <div v-if="item.status_id == 24 ||
                      item.status_id == 25 ||
                      item.status_id == 26 ||
                      item.status_id == 27 ||
                      item.status_id == 28 ||
                      item.status_id == 29 ||
                      item.status_id == 30 ||
                      item.status_id == 31 ||
                      item.status_id == 33 ||
                      item.status_id == 37 ||
                      item.status_id == 40 ||
                      item.status_id == 41">
                      <Icon
                        :circle=true
                        :name="statusInfo(item.status_id).icon"
                        size="20"
                        class="float-left m-r-15" />
                      <div class="float-left" style="width: 100%;">
                        <p class="big-info-text">{{ `${formatTime(item.created_time)} | ${getStatusMessageText(item.message) || $t(statusInfo(item.status_id).text)}` }}</p>
                        <p v-if="item.addition != null || item.addition != undefined"
                          class="small-info-text" style="word-break: break-word;">{{ item.addition.split(",").join(", ") }}</p>
                      </div>
                    </div>
                    <div v-else-if="[44].includes(parseInt(item.status_id))">
                      <Icon
                        :circle=true
                        name="truck"
                        size="20"
                        class="float-left m-r-15" />
                      <div class="float-left" style="width: 100%;">
                        <p class="big-info-text">{{ `${formatTime(item.created_time)} | ${$t('LBL_ADDED_TO')} ${get_single_shipment.pickup ? get_single_shipment.pickup.shipping_agent_name : ''} ${$t('LBL_PICKUP_WITH_PICKUP_NO')}` }}
                          <a class="pointer link small-info-text"
                             @click="$router.push(`/pickups/booked/${getStatusMessageText(item.message, '#', 1)}`)">
                            {{ (get_single_shipment.pickup && get_single_shipment.pickup.trace_no) ? (get_single_shipment.pickup.trace_no) : `#${getStatusMessageText(item.message, '#', 1)}` }}
                          </a>
                        </p>
                        <p class="small-info-text" style="word-break: break-word;">{{ item.addition }}</p>
                      </div>
                    </div>
                    <div v-else-if="[45, 47].includes(parseInt(item.status_id))">
                      <Icon
                        :circle=true
                        name="truck"
                        size="20"
                        class="float-left m-r-15" />
                      <div class="float-left" style="width: 100%;">
                        <p class="big-info-text">{{ `${formatTime(item.created_time)} | ${getStatusMessageText(item.message, '#', 0)}` }}
                          <a class="pointer link small-info-text"
                             @click="$router.push(`/pickups/${parseInt(item.status_id) === 47 ? 'not-planned' : 'booked'}/${getStatusMessageText(item.message, '#', 1)}`)">
                            {{`#${getStatusMessageText(item.message, '#', 1)}` }}
                          </a>
                        </p>
                        <p class="small-info-text" style="word-break: break-word;">{{ item.addition }}</p>
                      </div>
                    </div>
                    <div v-else>
                      <Icon
                        :circle=true
                        :name="statusInfo(item.status_id).icon"
                        :size="item.status_id == 3 ? '24' : '20'"
                        class="float-left m-r-15" />
                      <div class="float-left" style="width: 100%;">
                        <p class="big-info-text"
                           v-if="item.message.startsWith('CREATED_EOD_STATUS_MESSAGE') && item.message.includes('#')">
                          {{ `${formatTime(item.created_time)} | ${getStatusMessageText(item.message, '#', 0)}` }}
                          <a
                            class="small-info-text pointer link"
                            @click="$router.push(`/shipments/end-of-day/${getStatusMessageText(item.message, '#', 1)}`)">
                            #{{ getStatusMessageText(item.message, '#', 1) }}
                          </a>
                        </p>
                        <p class="big-info-text" v-else>{{ `${formatTime(item.created_time)} | ${getStatusMessageText(item.message)}` }}</p>
                        <p class="small-info-text" style="word-break: break-word;">{{ item.addition }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Popup
      v-if="emailPopupOpened"
      :popupSmall=true
      :showConfirmButton=false
      :showSendButton=true
      @cancel="closePopup"
      @confirm="emailWaybills">
      <template v-slot:header>
        <h2>{{ $t('E-mail waybills') }}</h2>
      </template>
      <div>
        <div class="m-b-30">
          <span class="d-block m-b-20">{{ $t('Who should receive waybills?') }}</span>
          <div>
            <div class="m-b-10">
              <Checkbox
                :label="$t('Shipper')"
                v-model="selectedShipper"
                @change="selectedShipper = !selectedShipper" />
            </div>
            <div class="m-b-10">
              <Checkbox
                :label="$t('receiver')"
                v-model="selectedReciever"
                @change="selectedReciever = !selectedReciever" />
            </div>
            <div class="m-b-20">
              <Checkbox
                :label="$t('Other')"
                v-model="selectedOther"
                @change="otherNotification" />
            </div>
            <InputText
              v-if="selectedOther"
              class="d-block"
              placeholder="Enter email"
              :label="$t('Other email notification')"
              v-model="otherMail" />
          </div>
        </div>
        <div>
          <span class="d-block textarea-label">{{ $t('Personal message') }}</span>
          <textarea class="textarea-input" v-model="emailMessage"></textarea>
        </div>
      </div>
    </Popup>
    <Popup
      v-if="uploadFileToAgentPopupOpened"
      :popupSmall=true
      :showConfirmButton=false
      :showSendButton=true
      @cancel="closePopup"
      @confirm="uploadFileToAgent">
      <template v-slot:header>
        <h2>{{ $t('Upload file') }}</h2>
      </template>
      <div>
        <div class="m-b-40">
            <InputSelect
              :label="$t('Additional file type?')"
              v-model="additionalFileType"
              :options="selectOptions(get_additional_file_types)"
              :rules="{required: true}"
            />
        </div>
        <div class="m-b-40">
          <div
            :class="'active brand'"
            class="button-bar"
            @click="addFile">
            <Icon
              class="m-r-20"
              name="cloudUpload"
              :circle="true"
              size="20"/>
            <div class="text-box">
              <input
                @change="newFile"
                type="file"
                ref="invButton"
                style="display:none"/>
              <span class="main-text">{{ $t('Choose file for upload') }}</span>
              <span class="sub-title" v-if="additionalFile !== null">{{ additionalFileName }}</span>
            </div>
          </div>
        </div>
      </div>
    </Popup>
    <Popup
      v-if="selectPrinterPopupOpened"
      minHeight="450px"
      :popupSmall=true
      :confirmText="$t('print')"
      @cancel="closePopup"
      @confirm="printWaybill">
      <template v-slot:header>
        <h2>{{ $t('reprint') }}</h2>
      </template>
      <div>
        <div class="m-b-40">
          <InputSelect
            class="m-b-40"
            :label="$t('printer')"
            v-model="popupPrinterId"
            :options="get_waybill_printers"/>
        </div>
      </div>
    </Popup>
    <!-- Generate New Customs Invoice Popup -->
    <Popup
      v-if="showGenerateCustomsInvoicePopup"
      :popupSmall=false
      :confirmText="$t('generate')"
      @cancel="closePopup"
      @confirm="generateNewCustomsInvoice">
      <template v-slot:header>
        <h2>{{ $t('generate_new_customs_invoice') }}</h2>
        <p class="small-info-text">{{ $t('customs_invoice_details') }}</p>
      </template>
      <div>
        <ShipmentContentBlock
          :isQuoteMode="false"
          :minimalMode="true"
          :useContentOnShipmentLevel="invoiceUseContentOnShipmentLevel"
          @toggleUseContentOnShipmentLevel="invoiceUseContentOnShipmentLevel = $event"
          :showColliContent="true"
          :showCustoms="true"
          :showOrigin="true"
          :isCustomsInvoiceUploaded="false"
          v-model="invoiceContentData"
        />
        <div class="separator"></div>
        <AdditionalInformation
          v-model="customsFormForInvoice"
          :invoiceFiles="invoiceFilesForInvoice"
          :selected-info-items="selectedInfoItemsForInvoice"
          :additional-info="additionalInfoForInvoice"
          :showUploadForm="false"
          :showFreightBy="true"
          :showIncoterms="true"
          :showCustoms="true"
          @selected-info-update="updateSelectedInfoForInvoice"
          @additional-info-update="updateAdditionalInfoForInvoice"
          @file-uploaded="addInvoiceFilesForInvoice"
        />
      </div>
    </Popup>
    <Popup v-if="showManualCancelPopup" :showConfirmButton="true" :showCancelButton="false" :confirmText="$t('got_it')" @confirm="closeManualCancelPopup"  @cancel="closeManualCancelPopup">
      <template v-slot:header>
        <h2>{{ $t('shippment_not_cancelled') }}</h2>
      </template>
      <div>
        <message name="warning" :data="data={data:information, type:'custom-message'}" v-for="(information, index) in shippmentManualCancel" :key="`error-${index}`"></message>
      </div>
    </Popup>
    <!-- PICKUP POPUP -->
    <Popup
      v-if="showMoveShipmentToBookedPickupPopup"
      min-height="400px"
      :popupLarge=true
      :showConfirmButton="!!Object.keys(selectedBookedPickup).length"
      @cancel="toggleMoveShipmentToBookedPickupPopup"
      @confirm="submitMoveShipmentToBookedPickup">
      <template v-slot:header>
        <h2>{{ $t('move_to_booked') }}</h2>
      </template>
      <div class="row">
        <div class="col-xs-12 m-b-20">
          <div class="row m-b-input">
            <div class="col-xs-12">
              <Calendar
                :label="$t('pickup_date')"
                v-model="moveShipmentToBookedPickupData.pickupDate"
                :rules="{required: true}" />
            </div>
          </div>
        </div>
      </div>
      <p>{{ $t('existing_pickup')}}</p>
      <div class="m-t-20">
        <div>
          <div>
            <div
              v-for="(existingPickup, index) in availableBookedPickups" :key="`mtttbb-row-${index}`" >
              <div class="toggle-card-box card no-padding">
                <div
                  @click="selectBookedPickupToMoveShipmentsIn(existingPickup)"
                  class="toggle-card-header"
                  :class="{ 'pickup-selected': !!Object.keys(selectedBookedPickup).length && parseInt(existingPickup.id) === parseInt(selectedBookedPickup.id) }">
                  <div class="info-box">
                    <div class="title-holder">
                      <LogosSVG :name="existingPickup.shipping_agent_name" size="62" class="m-r-20" />
                      <div>
                        <span class="sub-title m-b-5">{{ existingPickup.shipping_product_name}}</span>
                        <span class="title b-block m-b-5">{{ `${existingPickup.full_address}` }}</span>
                        <span class="sub-title">{{ `${existingPickup.packages_count} colli ` }} ({{ parseFloat(existingPickup.weight ? existingPickup.weight : 0) | weight }})</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Popup>
    <Popup
      v-if="showPickupPopup"
      min-height="400px"
      :popupLarge=true
      :showConfirmButton="false"
      @cancel="togglePickupPopup">
      <template v-slot:header>
        <h2>{{ $t('move_shipments_to_new_pickup') }}</h2>
      </template>
      <div>
        <div class="row">
          <div class="col-xs-12 m-b-20">
            <div class="row m-b-input">
              <div class="col-xs-5">
                <Calendar
                  :label="$t('pickup_date')"
                  v-model="pickupData.pickupDate"
                  :rules="{required: true}" />
              </div>
              <div class="col-xs-7">
                <InputText
                  v-cloak
                  v-model="pickupData.reference"
                  :label="$t('reference')"
                  :rules="{required: false}"
                />
              </div>
            </div>
            <InputSelect
              :class="isForeignPickupLocation ? 'm-b-input' : ''"
              :label="$t('pickup_location')"
              v-model="pickupLocationId"
              @change="checkForForeign"
              :countryFlag="true"
              :options="pickupLocationOptions"
            />
            <div class="row" v-if="isForeignPickupLocation">
              <div class="col-xs-6 m-b-20">
                <InputText
                  :label="$t('company_name')"
                  v-model="pickupData.company"
                  :rules="{required: true}" />
              </div>
              <div class="col-xs-6 m-b-20">
                <InputText
                  :label="$t('name')"
                  v-model="pickupData.attention"
                  :rules="{required: false}" />
              </div>
            </div>
            <AddressPicker
              class="m-b-input"
              v-if="isForeignPickupLocation"
              :label="$t('address_1')"
              placeholder="Search address"
              @addressSelected="changeAddress('pickup', $event)"
              v-model="pickupAddress"
            />
          </div>
        </div>
        <div class="row" v-if="isForeignPickupLocation">
          <div class="col-xs-6">
            <PhoneSelect v-model="pickupData.phone" :rules="{required: false}" />
          </div>
          <div class="col-xs-6">
            <InputText
              label="Email"
              v-model="pickupData.email"
              :rules="{required: false, email: false}" />
          </div>
        </div>
      </div>
      <!-- Products -->
      <message v-if="!productCardDataValid" name="warning" :data="data={data: this.productCardErrorMessage, type:'validation'}"></message>
      <div v-if="!reloadingProducts && productCardDataValid">
        <h2 class="m-b-20 p-t-30 section-title">{{ $t('pickup_options_on_this_address') }}</h2>
        <ProductCard
          v-for="(product, index) in productsList"
          :key="`product-${product.shipping_product_id}-${index}`"
          :product="product"
          :pickupLocationId="pickupLocationId"
          :pickupDate="pickupData.pickupDate"
          :pageType="'index'"
          :isOpened="(selectedProduct != null) && (selectedProduct.shipping_product_id == product.shipping_product_id)"
          :disableButton="disableButton"
          :loadingButton="loadingButton"
          @bookPickup="bookPickup"
          @selected="selectProduct" />
      </div>
    </Popup>
    <Popup v-if="showManualCancelPopup" :showConfirmButton="true" :showCancelButton="false" :confirmText="$t('got_it')" @confirm="closeManualCancelPopup"  @cancel="closeManualCancelPopup">
      <template v-slot:header>
        <h2>{{ $t('shippment_not_cancelled') }}</h2>
      </template>
      <div>
        <message name="warning" :data="data={data:information, type:'custom-message'}" v-for="(information, index) in shippmentManualCancel" :key="`error-${index}`"></message>
      </div>
    </Popup>
    <Popup
      v-if="showLastInPickupPopup"
      :showConfirmButton="false"
      :showCancelButton="true"
      @cancel="closeLastInPickupPopup"
    ><div>
        <!-- Loop through each empty pickup -->
        <div v-for="(pickup, index) in emptyPickups" :key="index" class="m-b-20">
          <div class="message-conatiner flex" style="background-color: #FCF8E3; border-color: #FAEBCC;">
            <div class="m-r-10 message-box" style="align-self:flex-start;">
              <Icon
                class="m-r-20"
                style="background-color: #F7F0C9"
                :circle=true
                fillColor="#755D32"
                name="warningSign"
                size="22"/>
            </div>
            <div class="custom-message">
              <p style="color: #755D32">
                {{ $t('shipment_is_in_scheduled_pickup', { trace_nos: pickup.shipment_trace_nos }) }}
                {{ $t('do_you_want_to_cancel_pickup') }}
              </p>
              <div class="m-t-20">
                <div class="clear-float" style="margin-top: auto">
                  <Btn
                    @click.native="keepPickup(index)"
                    class="brand float-left m-r-20"
                    style="background-color: black; color: white"
                    :icon="{
                    name: 'check',
                    size: '18',
                  }"
                    :btnText="$t('keep_the_pickup')"
                  />
                  <Btn
                    @click.native="cancelPickup(pickup, index)"
                    class="red float-left m-r-20"
                    :icon="{
                    name: 'deleteForever',
                    size: '18',
                  }"
                    :btnText="$t('cancel_the_pickup')"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Popup>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex';
import mixins from '@/mixins/mixins.js';
import date from '@/mixins/date';
import Popup from '@/components/global/popup';
import Dropdown from '@/components/global/dropdown';
import Btn from '@/components/elements/buttons';
import LogosSVG from "@/assets/images/logosSVG";
import Checkbox from '@/components/elements/inputs/checkbox.vue';
import InputText from '@/components/elements/inputs/text.vue';
import InputSelect from '@/components/elements/inputs/select';
import PhoneSelect from '@/components/elements/inputs/phone.vue';
import ProductCard from '@/components/pickup/productCard';
import Calendar from '@/components/elements/inputs/calendar.vue';
import AddressPicker from '@/components/global/addressPicker/index.vue';
import PickupPopupMixin from '@/mixins/bookPickupPopup';
import i18n from "../../i18n";
import shipment from "../../mixins/shipment";
import palletExchange from "../../components/elements/inputs/palletExchange.vue";
import AdditionalInformation from "@/components/shipments/additionalInformation.vue";
import ShipmentContentBlock from "@/components/shipments/shipmentContentBlock.vue";

export default {
  name: 'ViewShipment',
  mixins: [mixins, date, PickupPopupMixin],
  components: {
    Btn, LogosSVG, Dropdown, Popup, Checkbox, InputText,
    InputSelect, PhoneSelect, ProductCard, Calendar, AddressPicker,
    AdditionalInformation, ShipmentContentBlock
  },
  data() {
    return {
      shipmentFilePaths: {}, // Object for caching blob urls
      //Cancel pickup
      showLastInPickupPopup: false,
      emptyPickups: [], // List of empty pickups
      currentPickupIndex: 0, // Index of the currently selected pickup
      //Pickup stuff
      selectedProduct: null,
      productsList: [],
      disableButton: false,
      loadingButton: false,
      reloadingProducts: false,
      pickupLocationId: null,
      isForeignPickupLocation: true,
      productCardDataValid: false,
      showManualShipmentBlock: false,
      productCardErrorMessage: '',
      product: {},
      updateForm: {
        reference: '',
        driverNote: '',
        pickupDate: new Date(),
        pickupTimeFrom: '',
        pickupTimeUntil: ''
      },
      showMoveShipmentToBookedPickupPopup: false,
      showPickupPopup: false,
      availableBookedPickups: [],
      selectedBookedPickup: {},
      moveShipmentToBookedPickupData: {
        pickupDate: ''
      },
      //End pickup stuff
      downloadEodName: '',
      shippmentManualCancel: {},
      showManualCancelPopup: false,
      scanImagePath: '',
      podPath: '',
      cmrPath: '',
      markerLabels : "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
      strokeOptions: {
        strokeColor: '#017a75',
        // strokeColor: '#0088FF',
        strokeWeight: 6,
        strokeOpacity: 0.6
      },
      dropdownOptions: [
        {
          text: this.$t('copy_to_new'),
          subText: this.$t('Create with copied data'),
          icon: 'fileCopies',
          action: 'copy'
        },
        {
          text: this.$t('Create return'),
          subText: this.$t('Create with swaped data'),
          icon: 'reply',
          action: 'return'
        },
        {
          text: this.$t('Create EOD'),
          subText: this.$t('Create end of day'),
          icon: 'delivery',
          action: 'create_eod'
        },
        {
          text: this.$t('Print waybills'),
          subText: this.$t('Print waybills'),
          icon: 'printer',
          action: 'print'
        },
        {
          text: this.$t('Email waybills'),
          subText: this.$t('Email waybills'),
          icon: 'letter',
          action: 'email'
        },
        {
          text: this.$t('cancel'),
          subText: this.$t('Cancel shipment'),
          icon: 'deleteForever',
          action: 'cancel'
        },
        {
          text: this.$t('Upload file'),
          subText: this.$t('Send file to agent'),
          icon: 'cloudUpload',
          action: 'upload'
        },
        {
          text: this.$t('move_to_existing'),
          subText: this.$t('move_to_existing_subtext'),
          icon: 'swapVertical',
          action: 'move_to_existing_pickup'
        },
        {
          text: this.$t('move_shipments_to_new_pickup'),
          subText: this.$t('move_shipments_to_new_pickup_subtext'),
          icon: 'deliveryTime',
          action: 'move_to_new_pickup'
        },
        {
          text: this.$t('generate_new_customs_invoice'),
          subText: this.$t('customs_invoice_details'),
          icon: 'agreements',
          action: 'generate_new_customs_invoice'
        }
      ],
      invoicePdfPath: '',
      waybillPdfPath: '',
      dangerousGoodsPdfPath: '',
      additionalFilePdfPath: [],
      eodPdfPath: '',
      waybillsPdfPath: '',
      uploadFileToAgentPopupOpened: false,
      additionalFileType: '',
      selectPrinterPopupOpened: false,
      popupPrinterId: '',
      waybillPrinters: '',
      additionalFileName: '',
      additionalFile: null,
      emailPopupOpened: false,
      selectedShipper: true,
      selectedReciever: false,
      selectedOther: false,
      otherMail: '',
      emailMessage: '',
      waybillEmails: [],
      // Generate Customs Invoice popup
      showGenerateCustomsInvoicePopup: false,
      generateInvoiceLoading: false,
      // controls whether content lines are for entire shipment (true) or each colli (false)
      invoiceUseContentOnShipmentLevel: true,
      // Content lines for invoice (reuse booking content lines component)
      invoiceContentData: {
        description: '',
        content: [
          {
            qty: 1,
            description: '',
            unitWeight: { value: '', unit: 'kg' },
            unitValue: { value: '', unit: 'dkk' },
            hsCode: '',
            origin: ''
          }
        ]
      },
      selectedInfoItemsForInvoice: [],
      invoiceFilesForInvoice: [],
      customsFormForInvoice: {
        // mirrors AdditionalInformation v-model `value`
        goods_incoterm: '',
        duty_paid_by: null,
        duty_payer_account_no: '',
        freight_paid_by: null,
        freight_payer_account_no: '',
        freight_payer_id: null
      },
      additionalInfoForInvoice: {
        eori: '',
        eccn: '',
        customsAdditionalInfoText: '',
        eeiitn: {
          eei: '',
          tinType: '',
          tinNumber: ''
        },
      },
      financeGrouped: new Map(),
      totalBookedAmountGrouped: new Map(),
      totalInvoicedAmountGrouped: new Map(),
      totalInvoicedControlGrouped: new Map(),
      vatAmountGrouped: new Map(),
      showCustomsAction: false,
    };
  },
  mounted() {
    this.getComponentData()
  },
  computed: {
    customsFileLabel() {
      const additionalInfo = this.get_single_shipment?.additional_info;
      try {
        const parsed = typeof additionalInfo === 'string' ? JSON.parse(additionalInfo) : additionalInfo;
        const fileType = parsed?.customs_file_type;
        if (fileType && this.fileTypeLabelMap[fileType]) {
          return this.fileTypeLabelMap[fileType];
        }
      } catch (e) {}
      return this.$t('customs_invoice'); // default
    },
    fileTypeLabelMap() {
      return {
        'CMR': this.$t('cmr_document'),
        'CI': this.$t('customs_invoice'),
        'CLRI': this.$t('clearance_invoice'),
        'EAWB': this.$t('electronic_air_waybill'),
        'POD': this.$t('proof_of_delivery'), //
        'CORR': this.$t('correspondence'),
        'MRN': 'MRN',
        // Uploaded files
        'PF'   : this.$t('proforma_invoice'),
        'CINV' : this.$t('commercial_invoice'),
      };
    },
    getPickupDate() {
      const todayDate = new Date();
      const pickupDate = new Date(this.get_single_shipment.ship_date)
      const date =  pickupDate < todayDate ? todayDate : pickupDate;

      return this.getFormatedDate(date).date;
    },
    shipmentContentGroup() {
      return this.get_single_shipment.package_groups[0];
    },
    shipment() {
      return shipment
    },
    showVat() {
      return this.get_active_subaccount.is_vat && this.get_active_subaccount.vat_percent;
    },
    shipmentIsCalculatedByColli() {
      return parseInt(this.get_single_shipment.carrier_product.calculation_type) === 2;
    },
    setFinanceData() {
      this.financeGrouped.clear();
      this.totalBookedAmountGrouped.clear();
      this.totalInvoicedAmountGrouped.clear();
      this.totalInvoicedControlGrouped.clear();
      this.vatAmountGrouped.clear();

      if (!this.get_single_shipment.finance || !Array.isArray(this.get_single_shipment.finance)) return;

      this.get_single_shipment.finance.forEach((item) => {
        const bookedPrice = item.booked_price;
        const invoicedPrice = item.invoiced_price;
        const invoicedControlPrice = item.invoiced_control;
        const bookedInvoicedDiff = invoicedPrice - bookedPrice;
        const controlInvoicedDiff = invoicedControlPrice - invoicedPrice;
        const key = this.shipmentIsCalculatedByColli ? item.awb : 1;
        //Group data by awb
        if (!this.financeGrouped.get(key)) {
          this.financeGrouped.set(key, [item]);
        } else {
          this.financeGrouped.get(key).push(item);
        }

        //Set total BOOKED amounts grouped by awb
        if (!this.totalBookedAmountGrouped.get(key)) {
          this.totalBookedAmountGrouped.set(key, bookedPrice);
        } else {
          const newPrice = this.totalBookedAmountGrouped.get(key) + bookedPrice;
          this.totalBookedAmountGrouped.set(key, newPrice);
        }

        //Set total INVOICED amounts grouped by awb
        if (!this.totalInvoicedAmountGrouped.get(key)) {
          this.totalInvoicedAmountGrouped.set(key, invoicedPrice);
        } else {
          const newPrice = this.totalInvoicedAmountGrouped.get(key) + invoicedPrice;
          this.totalInvoicedAmountGrouped.set(key, newPrice);
        }

        //Set total INVOICED CONTROL amounts grouped by awb
        if (!this.totalInvoicedControlGrouped.get(key)) {
          this.totalInvoicedControlGrouped.set(key, invoicedControlPrice);
        } else {
          const newPrice = this.totalInvoicedControlGrouped.get(key) + invoicedControlPrice;
          this.totalInvoicedControlGrouped.set(key, newPrice);
        }
      });

      if (this.showVat) {
        this.totalBookedAmountGrouped.forEach((val, key) => {
          const vatAmount = Number(val ? (val / 100 * this.get_active_subaccount.vat_percent) : 0);
          const newTotalPrice = vatAmount + Number(val);
          this.vatAmountGrouped.set(key, vatAmount);
          this.totalBookedAmountGrouped.set(key, newTotalPrice);
        })
      }
    },
    availableDropdownOptions(){
      let dropdownOptions = [];
        this.dropdownOptions.forEach(dropdownOption => {
          if (this.get_single_shipment && this.get_single_shipment.status === 5 && dropdownOption.action === 'cancel') {
            return;
          }
          if (this.get_single_shipment && this.get_single_shipment.batch_number !== null && dropdownOption.action === 'create_eod') {
            return;
          }
          if (dropdownOption.action === 'generate_new_customs_invoice' && !this.showCustomsAction) {
            return;
          }
          if (this.get_is_ship365 && ['move_to_existing_pickup', 'move_to_new_pickup'].includes(dropdownOption.action)) {
            return;
          }
          dropdownOptions.push(dropdownOption)
        });

      return dropdownOptions;
    },
    ...mapGetters([
      'get_is_ship365',
      'get_single_shipment',
      'get_parcel_types',
      'get_parcel_type_name',
      'get_subaccounts',
      'get_additional_file_types',
      'get_waybill_printers',
      'get_active_subaccount',
      'get_user',
      'get_shipment_dangerous_goods',
      'get_pickup_locations'
    ]),
    markers() {
      return [
        {
          lat: Number(this.get_single_shipment.customer_address_address_1_latitude),
          lng: Number(this.get_single_shipment.customer_address_address_1_longitude),
        },
        {
          lat: Number(this.get_single_shipment.sender_address_1_latitude),
          lng: Number(this.get_single_shipment.sender_address_1_longitude),
        },
      ];
    },
    freightPaidByName() {
      if(this.get_single_shipment.freight_paid_by == 1) {
        return this.get_single_shipment.freight_payer_account_no ? `Seller (${this.get_single_shipment.freight_payer_account_no})`: 'Seller';
      } else if(this.get_single_shipment.freight_paid_by == 2) {
        return this.get_single_shipment.freight_payer_account_no ? `Other (${this.get_single_shipment.freight_payer_account_no})` : 'Other';
      } else if(this.get_single_shipment.freight_paid_by == 4) {
        return `${this.get_single_shipment?.payer?.name} (${this.get_single_shipment.freight_payer_account_no})`;
      }
    },
    path() {
      return [
        {
          lat: Number(this.get_single_shipment.customer_address_address_1_latitude),
          lng: Number(this.get_single_shipment.customer_address_address_1_longitude),
        },
        {
          lat: Number(this.get_single_shipment.sender_address_1_latitude),
          lng: Number(this.get_single_shipment.sender_address_1_longitude),
        },
      ];
    },
    center() {
      return {
        lat: Number(this.get_single_shipment.sender_address_1_latitude),
        lng: Number(this.get_single_shipment.sender_address_1_longitude),
      };
    },
    shouldShowDownloadSignatureLink() {
      return (this.get_single_shipment.scan_pod_paths != null && this.get_single_shipment.scan_pod_paths != '')
        || (this.get_single_shipment.status === 14 && this.get_single_shipment.shipping_agent_name === 'Danske Fragtmænd')
        || (this.get_single_shipment.status === 14 && this.get_single_shipment.shipping_agent_name === 'GLS')
        || (this.get_single_shipment.status === 14 && this.get_single_shipment.shipping_agent_name === 'Dachser')
        || (this.get_single_shipment.status === 14 && this.get_single_shipment.shipping_agent_name === 'FedEx')
        || (this.get_single_shipment.status === 14 && this.get_single_shipment.shipping_agent_name === 'DHL Express')
        || (this.get_single_shipment.status === 14 && this.get_single_shipment.shipping_agent_name === 'DSV')
    },
    shouldShowDownloadCMR() {
      const hasCMRFile = this.get_single_shipment.shipment_files?.some(
        file => file.file_type === 'CMR' && file.file_path
      );
      // const isStatus14DanskeFragtmend = this.get_single_shipment.status === 14 && this.get_single_shipment.shipping_agent_name === 'Danske Fragtmænd';
      // const isStatus14DSV = this.get_single_shipment.status === 14 && this.get_single_shipment.shipping_agent_name === 'DSV';

      return hasCMRFile && parseInt(this.get_single_shipment.status) === 14;
    },
    getAccountName() {
      let name = '-';
      if (this.get_single_shipment.is_shared_shipment) {
        name = this.get_single_shipment.subaccount_name + ' (' + this.get_single_shipment.company_name + ': ' + this.get_single_shipment.subaccount_id + ')'
      } else {
        name = this.get_subaccounts.filter((account) => account.id == this.get_single_shipment.subaccount_id)[0].name;
      }

      return name;
    },
    timelineArray() {
      let timelineArray = {};
      this.get_single_shipment.shipment_statuses.forEach((status) => {
        const createdAtFormatted = this.formatDate(status.created_at, 'ccc d MMM yyyy');

        if(timelineArray[createdAtFormatted] == null){
          timelineArray[createdAtFormatted] = [];
        }
        timelineArray[createdAtFormatted].push(status);
      });

      return timelineArray;
    },
    isCustomCarrier() {
      return !!this.get_single_shipment.custom_carrier_id;
    },
  },
  methods: {
    getFileTypeIcon(fileType) {
      return 'attach';
    },
    getFileTypeLabel(fileType) {
      return this.fileTypeLabelMap[fileType] || fileType;
    },
    downloadShipmentFile(file, index) {
      this.$store.dispatch('GET_SHIPMENT_FILE', {
        shipment_id: this.get_single_shipment.id,
        type: file.file_type
      }).then((res) => {
        this.$nextTick(() => {
          let blobFile = window.URL.createObjectURL(res);
          this.$refs[`downloadShipmentFile${file.id}`][0].href = blobFile;
          this.$set(this.shipmentFilePaths, file.id, blobFile);
          this.$refs[`downloadShipmentFile${file.id}`][0].click();
        });
      }).catch((e) => {
        this.$store.commit('SHOW_NOTIFICATION_BAR', {
          message: this.$t('file_not_found'),
          type: 'alert-window',
        });
      });
    },
    // Method to handle keeping a pickup
    keepPickup(index) {
      // Remove this pickup from the list without canceling it
      this.emptyPickups.splice(index, 1);
      // If all pickups have been decided upon, close the popup
      if (this.emptyPickups.length === 0) {
        this.closeLastInPickupPopup();
      }
    },
    // Method to handle canceling a pickup
    cancelPickup(pickup, index) {
      // Cancel the pickup
      this.$store.dispatch('CANCEL_PICKUP', {id: pickup.pickup_id}).then(() => {
        this.updateIterator++;
        // Show notification
        this.$store.commit('SHOW_NOTIFICATION_BAR', {
          message: this.$t('pickup_cancelled_successfully', { number: pickup.id }),
          type: 'success-window',
          iconName: 'check',
        });
        // Remove the cancelled pickup from the list
        this.emptyPickups.splice(index, 1);
        // If all pickups have been decided upon, close the popup
        if (this.emptyPickups.length === 0) {
          this.closeLastInPickupPopup();
        }
      });
    },
    // Method to close the popup
    closeLastInPickupPopup() {
      this.showLastInPickupPopup = false;
      this.emptyPickups = [];
    },
    //PICKUP
    bookPickup(childData) {
      const payload = {
        shipment_ids: [this.$route.params.id],
        allowed_awbs: childData.product.allowed_shipment_awbs,
        subaccount_id: this.get_active_subaccount.id,
        pickup_date: this.pickupData.pickupDate,
        reference: this.pickupData.reference,
        pickup_time_zone: childData.pickup_time_zone,
        pickup_time_from: childData.pickup_time_from,
        pickup_time_until: childData.pickup_time_until,
        pickup_driver_note: childData.pickup_driver_note,
        shipping_product_id: childData.product.shipping_product_id,
        address: this.getRequestFormattedAddress(),
        shipments: []
      }
      this.disableButton = true;
      this.loadingButton = true;
      this.$store.dispatch('BOOK_PICKUP', payload).then((resp) => {
        this.togglePickupPopup();
        this.$router.push(`/pickups/booked/${resp.id}`);
      }).finally(() => {
        this.disableButton = false;
        this.loadingButton = false;
      });
    },
    togglePickupPopup() {
      this.showPickupPopup = !this.showPickupPopup;
      this.clearBookPickupData();
    },
    clearBookPickupData() {
      this.pickupShipments = [];
      this.pickupData = {
        pickupDate: '',
        pickupTimeFrom: '',
        pickupTimeUntil: '',
        reference: '',
        company: '',
        attention: '',
        email: '',
        phone: {
          number: '',
          country: '',
        },
      };
      this.pickupAddress = {
        address_1: '',
        address_2: '',
        post_code: '',
        city: '',
        country_id: '',
        state: '',
      };
    },
    //MOVE SHIPMENT INTO BOOKED PICKUP
    toggleMoveShipmentToBookedPickupPopup() {
      this.showMoveShipmentToBookedPickupPopup = !this.showMoveShipmentToBookedPickupPopup;
      this.clearMoveShipmentToBookedPickupData();
    },
    selectBookedPickupToMoveShipmentsIn(val) {
      this.selectedBookedPickup = val;
    },
    clearMoveShipmentToBookedPickupData() {
      this.moveShipmentToBookedPickupData = {
        pickupDate: ''
      }
      this.availableBookedPickups = [];
      this.selectedBookedPickup = {};
    },
    getAvailableBookedPickups (pickupDate) {
      const peTransformed = this.parseUnknownDate(pickupDate).toFormat('dd.MM.yyyy');
      this.$store.dispatch('GET_AVAILABLE_BOOKED_PICKUPS', {
        id: this.get_single_shipment.pickup_id,
        shipmentIds: [this.$route.params.id],
        pickupDate: peTransformed,
      }).then((res) => {
        this.availableBookedPickups = res;
      });
    },
    submitMoveShipmentToBookedPickup() {
      if (!Object.keys(this.selectedBookedPickup).length) {
        console.log('Pickup not selected');
        return;
      }

      const payload = {
        data: {
          ...this.moveShipmentToBookedPickupData
        },
        shipmentIds: [this.$route.params.id],
        moveFromPickupId: this.get_single_shipment.pickup_id,
        moveToPickupId: this.selectedBookedPickup.id
      };
      this.$store.dispatch('MOVE_SHIPMENTS_TO_BOOKED_PICKUP', payload).then((res) => {
        this.toggleMoveShipmentToBookedPickupPopup();
        this.$store.dispatch('GET_BOOKED_PICKUP_SHIPMENTS', {id: this.$route.params.id});
        if (res.data.data.shipments_count === 0) {
          this.$router.push('/pickups/booked');
        }
      });
    },
    //END PICKUP
    getPackageTrackingLink(rawLink, traceNo, shipmentId, shipmentUuid) {
      if (!rawLink) return '';
      let link = rawLink.replace('{trace_key}', traceNo);
      link = link.replace('{shipment_id}', String(shipmentId));
      return link.replace('{shipment_uuid}', String(shipmentUuid));
    },
    colliNumberClasses(group) {
      return ['content-item', 'm-b-10', group.packages.length > 1 ? 'col-xs-6' : 'col-xs-12'];
    },
    resolveClassByAmount(amount) {
      if (amount < 0) {
        return 'text-warning';
      }
      if (amount > 0) {
        return 'text-error';
      }
      if (amount === 0) {
        return 'text-success';
      }
      return ''
    },
    packageName(shipmentPackage){
      if( shipmentPackage.goods_type == 1){
        return this.$t('parcel');
      } else if (shipmentPackage.goods_type == 2){
        return this.$t('document');
      } else if (shipmentPackage.goods_type == 3){
        return this.$t('pallet');
      } else {
        return this.$t('load');
      }
    },
    getFinanceBillingWeight(awb) {
      //If caclulation is by colli then return colli billing weight otherwise shipment weight
      if (this.shipmentIsCalculatedByColli) {
        const colli = this.get_single_shipment.packages.filter((item) => {
          return item.package_trace_no === awb;
        });

        if (!colli.length) {
          return 0;
        }

        return colli[0].billing_weight;
      }

      return this.get_single_shipment.billing_weight;
    },
    closeManualCancelPopup() {
      this.showManualCancelPopup = false;
      this.shippmentManualCancel = {};
    },
    getStatusMessageText(message, breakpoint, part) {
      //Translate first index of array
      if (message && message.includes('@separator0@')) {
        const statusMsgArray = message.split('@separator0@');
        return `${this.$t(statusMsgArray[0])} ${statusMsgArray[1]}`;
      }

      if (breakpoint && message && message.includes(breakpoint)) {
        const statusMsgArray = message.split(breakpoint);
        const translationString = statusMsgArray[part] ? statusMsgArray[part].trim() : '';
        return `${this.$t(translationString)}`;
      }

      return `${this.$t(message)}`
    },
    iconType(type) {
      if(type == 1) return 'truck';
      if(type == 5) return 'document';
      if(type == 6) return 'deliveryTime';
      if(type == 9) return 'fuel';
      if(type == 'vat') return 'vatIcon';
      if(type == 'sum') return 'sumSign';
    },
    statusInfo(statusNumber) {
      statusNumber = parseInt(statusNumber);
      if(parseInt(statusNumber) === 34){
        return {
          class: 'step1',
          icon: 'clock',
          text: 'Waiting for approval',
        };
      }
      if(parseInt(statusNumber) === 35){
        return {
          class: 'step1',
          icon: 'checkMan',
          text: 'Approved by carrier',
        };
      }
      if(parseInt(statusNumber) === 3){
        return {
          class: 'step1',
          icon: 'check',
          text: 'Booked',
        };
      } else if (parseInt(statusNumber) === 41) {
        //label printed status
        return {
          class: 'step1',
          icon: 'printer',
          text: 'Booked',
        };
      } else if(parseInt(statusNumber) === 23){
        return {
          class: 'step1',
          icon: 'ban',
          text: 'Waiting for departure',
        };
      } else if(parseInt(statusNumber) === 5) {
        return {
          class: 'step1',
          icon: 'deleteForever',
          text: 'canceled',
        };
      } else if(
        parseInt(statusNumber) === 13 ||
        parseInt(statusNumber) === 17 ||
        parseInt(statusNumber) === 12) {
        return {
          class: 'step2',
          icon: 'delivery',
           text: 'transit',
        };
      }else if(parseInt(statusNumber) === 4) {
        return {
          class: 'step2',
          icon: 'agreements',
          text: 'transit',
        };
      } else if (parseInt(statusNumber) === 15) {
        return {
          class: 'step3-pickup',
          icon: 'pin',
          text: 'In Pickup Point',
        };
      } else if(parseInt(statusNumber) === 8 || parseInt(statusNumber) === 16) {
        return {
          class: 'step3',
          icon: 'warning',
           text: 'Deviation',
        };
      } else if(parseInt(statusNumber) === 14) {
        return {
          class: 'step4',
          icon: 'check',
           text: 'Delivered',
        };
      } else if(parseInt(statusNumber) === 1) {
        return {
          class: 'step4',
          icon: 'check',
           text: 'PENDING',
        };
      } else if(
        parseInt(statusNumber) === 24 ||
        parseInt(statusNumber) === 25 ||
        parseInt(statusNumber) === 26 ||
        parseInt(statusNumber) === 27 ||
        parseInt(statusNumber) === 28 ||
        parseInt(statusNumber) === 29 ||
        parseInt(statusNumber) === 30 ||
        parseInt(statusNumber) === 31 ||
        parseInt(statusNumber) === 33 ||
        parseInt(statusNumber) === 40 ) {
        return {
          class: 'step2',
          icon: 'letter',
          text: 'transit',
        };
      } else if(parseInt(statusNumber) === 32) {
        return {
          class: 'step1',
          icon: 'attach',
          text: 'File upload',
        };
      } else if(parseInt(statusNumber) === 42) {
        return {
          class: 'step1',
          icon: 'warning',
          text: '',
        };
      } else {
        return {
          class: 'step1',
          icon: 'check',
          text: '',
        };
      }
    },
    optionSelected(val, optObject) {
      if (optObject.action === 'move_to_existing_pickup') {
        this.toggleMoveShipmentToBookedPickupPopup();
        this.getAvailableBookedPickups(this.getPickupDate)
      }
      if (optObject.action === 'move_to_new_pickup') {
        this.pickupAddress = {
          address_1: this.get_single_shipment.sender_waybill_address_1,
          address_2: this.get_single_shipment.sender_waybill_address_2,
          post_code: this.get_single_shipment.sender_waybill_post_code,
          city: this.get_single_shipment.sender_waybill_city,
          country_id: this.get_single_shipment.sender_waybill_country_id,
          state: this.get_single_shipment.sender_waybill_state,
        };
        this.pickupData = {
          ...this.pickupData,
          company: this.get_single_shipment.sender_waybill_company_name,
          attention: this.get_single_shipment.sender_waybill_name,
          email: this.get_single_shipment.sender_waybill_email,
          phone: {
            number: this.get_single_shipment.sender_waybill_phone,
            country: this.getCountry(this.get_single_shipment.sender_waybill_country_id, 'alpha2'),
          },
        };
        this.openCreatePickupPopup();
      }
      if(optObject.action === 'copy') {
        // Create NEW SHIPMENT
        let shipmentId = this.$route.params.id;
        this.$store.dispatch('GET_SHIPMENT', shipmentId).then((res) => {
          this.$store.dispatch('SET_EDITING_SHIPMENT', res).then(() => {
            this.$router.push('/shipments/book-shipment');
          });
        });
      }
      if(optObject.action === 'return') {
        // Create NEW SHIPMENT
        let shipmentId = this.$route.params.id;
        this.$store.dispatch('GET_SHIPMENT', shipmentId).then((res) => {
          this.$store.dispatch('SET_EDITING_SHIPMENT', {...res, inverted: true, is_return: true}).then(() => {
            this.$router.push('/shipments/book-shipment');
          });
        });
      }
      if(optObject.action === 'create_eod') {
        // Create EOD
        this.$store.dispatch('CREATE_EOD', this.get_single_shipment.id).then((res) => {
          this.downloadEodName = `EOD_${res.batch_number}`;
          this.$store.dispatch('DOWNLOAD_EOD', res.batch_number).then((res) => {
            this.$nextTick(() => {
              let file = window.URL.createObjectURL(res);
              this.$refs.downloadEODPDF.href = file;
              this.eodPdfPath = file;
              this.$refs.downloadEODPDF.click();
            })
          })
        }).finally(() => this.getComponentData());
      }
      if(optObject.action === 'print') {
        if (this.get_user.label_printer_id && parseInt(this.get_user.label_printer_id) > 0) {
          this.selectPrinterPopupOpened = true;
          this.popupPrinterId = this.get_single_shipment.user.label_printer_id
        } else {
          this.$store.dispatch('GET_LABEL', this.get_single_shipment.id)
            .then((res) => {
              const blob = new Blob([res], { type: 'application/pdf' });
              const blobUrl = URL.createObjectURL(blob);

              const printFrame = document.createElement('iframe');
              printFrame.style.position = 'fixed';
              printFrame.style.right = '-9999px'; // Position off-screen
              printFrame.style.bottom = '-9999px';
              printFrame.style.width = '0';
              printFrame.style.height = '0';
              document.body.appendChild(printFrame);

              printFrame.onload = () => {
                printFrame.contentWindow.print();

                const cleanUp = () => {
                  URL.revokeObjectURL(blobUrl);
                  document.body.removeChild(printFrame);
                };

                printFrame.contentWindow.onafterprint = cleanUp;
                setTimeout(cleanUp, 60000);
              };

              printFrame.src = blobUrl;
            })
            .catch(error => {
              console.error('Error getting label:', error);
            });
        }
      }
      if(optObject.action === 'email') {
        // Create EOD
        this.emailPopupOpened = true;
      }
      if(optObject.action === 'cancel') {
        // Create EOD
        this.$store.dispatch('CANCEL_SHIPMENT', this.get_single_shipment.id).then( r => {

          const response = r.data.data;
          if (response.failed) {
            for (let shippmentId in response.failed) {
              this.$store.commit('SHOW_NOTIFICATION_BAR', {
                message: response.failed[shippmentId].status,
                type: 'alert-window',
              });
            }
          }
          if (response.success) {
            for (let shippmentId in response.success) {
              if (response.success[shippmentId].status === 'agent_does_not_have_cancel_option') {
                if (!this.shippmentManualCancel[response.success[shippmentId].agent_id]) {
                  const agent = response.success[shippmentId].agent_info;
                  const shippment = this.get_single_shipment;
                  const carrierPhone = agent.phone;//shippment.custom_carrier ? shippment.custom_carrier.customer_service_phone : agent.phone;
                  const carrierEmail = agent.email; //shippment.custom_carrier ? shippment.custom_carrier.customer_service_email :  agent.email;
                  const carrierName = agent.name //shippment.custom_carrier ? shippment.custom_carrier.name : agent.name,

                  if (carrierPhone && carrierEmail) {
                    this.shippmentManualCancel[response.success[shippmentId].agent_id] = i18n.t('shipping_agent_does_not_have_cancel_option_view', {
                      carrier_name: carrierName,
                      carrier_phone: carrierPhone,
                      carrier_email: carrierEmail,
                      trace_no: shippment.trace_no
                    });
                  } else if (carrierPhone) {
                    this.shippmentManualCancel[response.success[shippmentId].agent_id] = i18n.t('shipping_agent_does_not_have_cancel_option_without_email_view', {
                      carrier_name: carrierName,
                      carrier_phone: carrierPhone,
                      trace_no: shippment.trace_no
                    });
                  } else if (carrierEmail) {
                    this.shippmentManualCancel[response.success[shippmentId].agent_id] = i18n.t('shipping_agent_does_not_have_cancel_option_without_phone_view', {
                      carrier_name: carrierName,
                      carrier_email: carrierEmail,
                      trace_no: shippment.trace_no
                    });
                  }
                  if (parseInt(this.get_active_subaccount.backoffice_id) === 1) {
                    this.showManualCancelPopup = true;
                  } else {
                    this.$store.commit('SHOW_NOTIFICATION_BAR', {
                      message: i18n.t('shipment_is_cancelled'),
                      type: 'success-window',
                      iconName: 'check',
                    });
                  }
                }
              }

              if (response.empty_pickups && response.empty_pickups.length > 0) {
                this.emptyPickups = response.empty_pickups;
                this.currentPickupIndex = 0;
                this.showLastInPickupPopup = true;
              }
            }
          }
        }).finally(() => this.getComponentData());
      }
      if(optObject.action === 'upload') {
        this.uploadFileToAgentPopupOpened = true;
      }
      if (optObject.action === 'generate_new_customs_invoice') {
        this.openGenerateCustomsInvoicePopup();
      }
    },
    closePopup() {
      this.emailPopupOpened = false;
      this.uploadFileToAgentPopupOpened = false
      this.selectPrinterPopupOpened = false
      this.showGenerateCustomsInvoicePopup = false
    },
    otherNotification() {
      this.selectedOther = !this.selectedOther;
      if(!this.selectedOther) {
        this.otherMail = '';
      }
    },
    printWaybill() {
      this.$store.dispatch('PRINT_LABEL', {shipment_id: this.get_single_shipment.id, printer_id: this.popupPrinterId}).then((res) => {
        this.closePopup()
        this.getComponentData()
      })
    },
    emailWaybills() {
      let mailList = [];
      if(this.selectedShipper) {
        mailList.push(this.get_single_shipment.sender_email)
      }

      if(this.selectedReciever) {
        mailList.push(this.get_single_shipment.customer_address_email)
      }

      this.$store.dispatch('EMAIL_WAYBILLS', {
        emails: this.otherMail.length > 0 ? [...mailList, ...this.otherMail.split(',')] : [...mailList],
        message: this.emailMessage,
        id: this.get_single_shipment.id,
      }).then(() => {
        this.emailPopupOpened = false;
      });
    },
    uploadFileToAgent() {
      const maxFileSize = 4 * 1024 * 1024; // 4MB
      if (this.additionalFile.size > maxFileSize) {
        alert("File is too big, 4mb is max file size");
        return;
      }
      let formData = new FormData();
      formData.append('file', this.additionalFile)
      this.$store.dispatch('UPLOAD_ADDITIONAL_FILE', {
        shipment_id: this.get_single_shipment.id,
        type: this.additionalFileType,
        file: formData,
      }).then(() => {
        this.closePopup()
        this.getComponentData()
      });
    },
    selectOptions(obj) {
      const options = [];
      for (const property in obj) {
        options.push({ text: obj[property], value: property });
      }
      return options;
    },
    // ===== Generate New Customs Invoice (Dummy) =====
    openGenerateCustomsInvoicePopup() {
      // Prefill from viewed shipment when available
      const s = this.get_single_shipment || {};
      this.customsFormForInvoice = {
        goods_incoterm: s.goods_incoterm || 'DAP',
        duty_paid_by: s.duty_paid_by != null ? s.duty_paid_by : null,
        duty_payer_account_no: s.duty_payer_account_no || '',
        freight_paid_by: s.freight_paid_by != null ? s.freight_paid_by : null,
        freight_payer_account_no: s.freight_payer_account_no || '',
        freight_payer_id: s.freight_payer_id || null
      };
      // Safely read nested customs additional info if present
      const customsAddJson = s.customs_additional_json || {};
      const eeiitnFromShipment = customsAddJson && customsAddJson.eeiitn ? customsAddJson.eeiitn : {};

      this.additionalInfoForInvoice = {
        eori: s.eori || '',
        eccn: s.eccn || '',
        customsAdditionalInfoText: s.customs_additional_info_text || '',
        mrn: s.customs_reference || '',
        eeiitn: {
          eei: eeiitnFromShipment.eei || s.eei || '',
          tinType: eeiitnFromShipment.tinType || s.tin_type || '',
          tinNumber: eeiitnFromShipment.tinNumber || s.tin_number || ''
        },
      };

      // Preselect additional info items based on available values so UI fields are visible
      const preselected = [];
      if (this.additionalInfoForInvoice.eccn) preselected.push('2');
      if (this.additionalInfoForInvoice.eeiitn && (this.additionalInfoForInvoice.eeiitn.eei || this.additionalInfoForInvoice.eeiitn.tinType || this.additionalInfoForInvoice.eeiitn.tinNumber)) preselected.push('3');
      if (this.additionalInfoForInvoice.customsAdditionalInfoText) preselected.push('22');
      if (this.additionalInfoForInvoice.mrn) preselected.push('4');
      this.selectedInfoItemsForInvoice = preselected;
      this.invoiceFilesForInvoice = [];
      // initialize toggle state from shipment if available
      this.invoiceUseContentOnShipmentLevel = typeof s.use_content_on_shipment_level === 'boolean' ? s.use_content_on_shipment_level : !!s.use_content_on_shipment_level;
      // Prefill content lines with weight and value extracted from shipment
      const shipmentDescription = s.goods_description || s.description || '';
      const packages = Array.isArray(s.packages) ? s.packages : [];
      let contentLines = [];

      // Resolve currency unit (lowercase as used by components)
      const currencyUnit = ((s.goods_value_currency
        || s.customer_address_currency_code
        || s.shipping_salesprice_currency
        || this.get_user?.currency
        || 'DKK') + '').toLowerCase();

      // Helpers to coerce numbers safely
      const toNum = (v, d = 0) => {
        const n = parseFloat(v);
        return isNaN(n) ? d : n;
      };

      // Total goods value (for customs) from shipment; default 0 if not set
      const totalGoodsValue = toNum(s.goods_value, 0);

      // Build content lines from shipmentContentGroup if available, else from packages
      const shipmentContentGroup = this.shipmentContentGroup;
      const shipmentContent = shipmentContentGroup && Array.isArray(shipmentContentGroup.content) ? shipmentContentGroup.content : [];

      if (shipmentContent.length > 0) {
        contentLines = shipmentContent.map((item) => {
          return {
            qty: toNum(item.quantity || item.qty, 1),
            description: item.description || shipmentDescription,
            unitWeight: { value: toNum(item.unit_weight, 0), unit: (item.unit_weight_unit || 'kg').toLowerCase() },
            unitValue: { value: toNum(item.unit_value, 0), unit: (item.unit_value_unit || currencyUnit).toLowerCase() },
            hsCode: item.hs_code || '',
            origin: item.origin_country_id || item.origin || ''
          };
        });
      } else if (packages.length > 0) {
        // Sum of package weights for proportional value split
        const totalPkgWeight = packages.reduce((sum, p) => sum + toNum(p.weight, 0), 0);

        contentLines = packages.map((p, idx) => {
          const pkgWeight = toNum(p.weight, 0) || toNum(s.weight, 0) || toNum(s.billing_weight, 0) || 0;
          // Proportionally distribute goods value by weight if possible, else equal split
          let valueShare = 0;
          if (totalGoodsValue > 0) {
            if (totalPkgWeight > 0) {
              valueShare = (pkgWeight / totalPkgWeight) * totalGoodsValue;
            } else {
              valueShare = totalGoodsValue / packages.length;
            }
          }
          return {
            qty: 1,
            description: p.description || shipmentDescription,
            unitWeight: { value: Number(pkgWeight.toFixed(2)), unit: 'kg' },
            unitValue: { value: Number(valueShare.toFixed(2)), unit: currencyUnit },
            hsCode: '',
            origin: ''
          };
        });
      } else {
        // Single-line fallback when there are no individual packages in payload
        const fallbackWeight = toNum(s.weight, 0) || toNum(s.billing_weight, 0) || 0;
        contentLines = [
          {
            qty: 1,
            description: shipmentDescription,
            unitWeight: { value: Number(fallbackWeight.toFixed(2)), unit: 'kg' },
            unitValue: { value: Number(totalGoodsValue.toFixed(2)), unit: currencyUnit },
            hsCode: '',
            origin: ''
          }
        ];
      }

      // Ensure at least one line exists with defaults if extraction failed
      if (contentLines.length === 0) {
        contentLines = [
          {
            qty: 1,
            description: shipmentDescription,
            unitWeight: { value: 0, unit: 'kg' },
            unitValue: { value: 0, unit: currencyUnit },
            hsCode: '',
            origin: ''
          }
        ];
      }

      this.invoiceContentData = {
        description: shipmentDescription,
        content: contentLines
      };
      this.showGenerateCustomsInvoicePopup = true;
    },
    updateSelectedInfoForInvoice(val) {
      this.selectedInfoItemsForInvoice = Array.isArray(val) ? val : [];
    },
    updateAdditionalInfoForInvoice(val) {
      this.additionalInfoForInvoice = { ...this.additionalInfoForInvoice, ...val };
    },
    addInvoiceFilesForInvoice(files) {
      this.invoiceFilesForInvoice = files || [];
    },
    async generateNewCustomsInvoice() {
      try {
        this.generateInvoiceLoading = true;

        // Clean additional_info - remove empty values
        const cleanedAdditionalInfo = { ...this.additionalInfoForInvoice };

        // Clean eeiitn - set to null if all values are empty
        if (cleanedAdditionalInfo.eeiitn) {
          const eeiitn = cleanedAdditionalInfo.eeiitn;
          const hasEeiValue = eeiitn.eei && eeiitn.eei.trim() !== '';
          const hasTinType = eeiitn.tinType && eeiitn.tinType.toString().trim() !== '';
          const hasTinNumber = eeiitn.tinNumber && eeiitn.tinNumber.trim() !== '';

          if (!hasEeiValue && !hasTinType && !hasTinNumber) {
            cleanedAdditionalInfo.eeiitn = null;
          }
        }

        // Remove empty string values
        Object.keys(cleanedAdditionalInfo).forEach(key => {
          if (cleanedAdditionalInfo[key] === '' || cleanedAdditionalInfo[key] === undefined) {
            cleanedAdditionalInfo[key] = null;
          }
        });

        const payload = {
          shipment_id: this.get_single_shipment?.id,
          customs: this.customsFormForInvoice,
          additional_info: cleanedAdditionalInfo,
          selected_info_items: this.selectedInfoItemsForInvoice,
          content_lines: this.invoiceContentData?.content || [],
          content_description: this.invoiceContentData?.description || ''
        };
        await this.$store.dispatch('GENERATE_NEW_INVOICE', payload);
        this.$store.commit('SHOW_NOTIFICATION_BAR', {
          message: i18n.t('generated'),
          type: 'success-window',
          iconName: 'check',
        });
        this.showGenerateCustomsInvoicePopup = false;
        this.getComponentData();
      } catch (e) {
        this.$store.commit('SHOW_NOTIFICATION_BAR', {
          message: (e && e.message) ? e.message : 'Error',
          type: 'alert-window',
        });
      } finally {
        this.generateInvoiceLoading = false;
      }
    },
    addFile() {
      this.$refs.invButton.click();
    },
    newFile() {
      this.additionalFile = this.$refs.invButton.files[0]
      this.additionalFileName = this.$refs.invButton.files[0].name;
    },
    countryName(id){
      return this.getCountry(id, 'name');
    },
    getShipmentGoodsTypeText(shipment) {
      const goodsTypes = {
        1: 'parcel',
        2: 'document',
        3: 'pallet',
        4: 'load'
      };

      const counts = {
        parcel: 0,
        document: 0,
        pallet: 0,
        load: 0
      };

      shipment.packages.forEach((pack) => {
        const type = goodsTypes[pack.goods_type];
        if (type) {
          counts[type]++;
        }
      });

      return Object.entries(counts)
        .filter(([type, count]) => count > 0)
        .map(([type, count]) => `${count} x ${this.$t(type)}`)
        .join(', ');
    },
    goodTypeName(type, usePlural = false) {
      if(parseInt(type) === 1) {
        return {
          name: usePlural ? this.$t('parcelss') : this.$t('parcel'),
          icon: 'savedItems',
        };
      }
      if(parseInt(type) === 2){
        return {
          name: usePlural ? this.$t('documentss') : this.$t('document'),
          icon: 'documentGoods',
        };
      }
      if(parseInt(type) === 3){
        return {
          name: usePlural ? this.$t('palletss') : this.$t('pallet'),
          icon: 'pallet',
        };
      }
      if(parseInt(type) === 4){
        return {
          name:  usePlural ? this.$t('loadss') : this.$t('load'),
          icon: 'delivery',
        };
      }
    },
    linkCall(val) {
      window.open(val, '_blank');
      // this.$store.dispatch('GET_TRACKING_LINK', val).then((res) => {
      //
      // });
    },
    formatPallets() {
      const packageGroups = this.get_single_shipment?.package_groups;
      const totalExchange = [
        {id : '1_1', value : 0, name: '1/1 ' + i18n.t('Pallet')},
        {id : '1_2', value : 0, name: '1/2 ' + i18n.t('Pallet')},
        {id : '1_4', value : 0, name: '1/4   ' + i18n.t('Pallet')},
      ]
      packageGroups.forEach(group => {
        if(group.pallet_exchange) {
          group.pallet_exchange.forEach(pe => {
            totalExchange.forEach(te => {
              if (te.id === pe.id) {
                te.value += parseInt(pe.value);
              }
            })
          })
        }
      })
      const exchangePallets = totalExchange.filter(item => item.value > 0);
      if (exchangePallets) {
        return exchangePallets.map(item => `${item.value} x ${item.name}` ).join(', ')
      }
    },
    downloadEOD() {
      this.$store.dispatch('DOWNLOAD_EOD', this.get_single_shipment.batch_number).then((res) => {
        this.$nextTick(() => {
          let file = window.URL.createObjectURL(res);
          this.$refs.downloadEODPDF.href = file;
          this.eodPdfPath = file;
          this.$refs.downloadEODPDF.click();
        })
      })
    },
    downloadInvoice() {
      this.$store.dispatch('GET_CUSTOMS_PDF', this.get_single_shipment.id).then((res) => {
        this.$nextTick(() => {
          let file = window.URL.createObjectURL(res);
          this.$refs.downloadInvoicePDF.href = file;
          this.invoicePdfPath = file;
          this.$refs.downloadInvoicePDF.click();
        })
      })
    },
    downloadWaybill() {
      this.$store.dispatch('GET_LABEL', this.get_single_shipment.id).then((res) => {
        this.$nextTick(() => {
          let file = window.URL.createObjectURL(res);
          this.$refs.downloadWaybillPDF.href = file;
          this.waybillPdfPath = file;
          this.$refs.downloadWaybillPDF.click();
        })
      })
    },
    downloadScanImage() {
      this.$store.dispatch('GET_SCAN_IMAGE', this.get_single_shipment.id).then((res) => {
        this.$nextTick(() => {
          let file = window.URL.createObjectURL(res);
          this.$refs.downloadScanImage.href = file;
          this.scanImagePath = file;
          this.$refs.downloadScanImage.click();
        })
      })
    },
    downloadPOD() {
      this.$store.dispatch('GET_POD', this.get_single_shipment.id)
        .then((res) => {
          this.$nextTick(() => {
            let file = window.URL.createObjectURL(res);
            this.$refs.downloadPODref.href = file;
            this.podPath = file;
            this.$refs.downloadPODref.click();
          })
        }).catch((e) => {
        this.$store.commit('SHOW_NOTIFICATION_BAR', {
          message: 'POD_not_found',
          type: 'alert-window',
        });
      })
    },
    downloadCMR() {
      this.$store.dispatch('GET_CMR', this.get_single_shipment.id)
        .then((res) => {
          this.$nextTick(() => {
            let file = window.URL.createObjectURL(res);
            this.$refs.downloadCMRref.href = file;
            this.cmrPath = file;
            this.$refs.downloadCMRref.click();
          })
        }).catch((e) => {
        this.$store.commit('SHOW_NOTIFICATION_BAR', {
          message: 'CMR_not_found',
          type: 'alert-window',
        });
      })
    },
    downloadDGFile() {
      this.$store.dispatch('GET_DG_FILE', this.get_single_shipment.id).then((res) => {
        this.$nextTick(() => {
          let file = window.URL.createObjectURL(res);
          this.$refs.downloadDgRef.href = file;
          this.podPath = file;
          this.$refs.downloadDgRef.click();
        })
      })
    },
    downloadAdditionalFile(type) {
      this.$store.dispatch('GET_ADDITIONAL_FILE', {shipment_id: this.get_single_shipment.id, type: type}).then((res) => {
        this.$nextTick(() => {
          let file = window.URL.createObjectURL(res);
          this.$refs[`downloadAdditionalFile${type}`][0].href = file;
          this.additionalFilePdfPath[type] = file;
          this.$refs[`downloadAdditionalFile${type}`][0].click();
        })
      })
    },
    routeIt() {
      this.$router.go(-1);
    },
    checkCustoms() {
      if (!this.get_single_shipment) return;
      let goodsType = [1]; // Default to Parcel if not specified
      if (this.get_single_shipment.goods_type && Array.isArray(this.get_single_shipment.goods_type)) {
        goodsType = this.get_single_shipment.goods_type.map(gt => {
          if (typeof gt === 'object' && gt !== null) {
            return gt.goods_type_id;
          }
          return gt;
        });
      }
      this.$store.dispatch('GET_CUSTOMS_DECLARABLE', {
        fromCountry: this.get_single_shipment.sender_country_id,
        fromPostcode: this.get_single_shipment.sender_post_code,
        toCountry: this.get_single_shipment.customer_address_country_id,
        toPostcode: this.get_single_shipment.customer_address_post_code,
        goods_type: JSON.stringify(goodsType),
      }).then((res) => {
        this.showCustomsAction = res;
      })
    },
    async getComponentData() {
      this.$store.dispatch('CLEAR_SHIPMENT');
      this.$store.dispatch('GET_SHIPMENT', this.$route.params.id).then((res) => {
        this.$store.dispatch('STORE_SHIPMENT', res);
        this.checkCustoms();
        this.$store.dispatch('GET_PARCEL_TYPES');
        this.$store.dispatch('GET_ADDITIONAL_FILE_TYPES', {agent: this.get_single_shipment.agent.id});
        this.$store.dispatch('GET_OPTIONS_FOR_WAYBILL_PRINTERS', {popupPrinterId: this.get_single_shipment.user.label_printer_id});
        this.setFinanceData;
        this.downloadEodName = `EOD_${this.get_single_shipment ? this.get_single_shipment.batch_number : '' }`;
        this.$nextTick(() => {
          this.$refs.mapRef.$mapPromise.then((map) => {
            var markerBounds = new window.google.maps.LatLngBounds();
            markerBounds.extend({lat: Number(this.get_single_shipment.customer_address_address_1_latitude), lng: Number(this.get_single_shipment.customer_address_address_1_longitude)})
            markerBounds.extend({lat: Number(this.get_single_shipment.sender_address_1_latitude), lng: Number(this.get_single_shipment.sender_address_1_longitude)});
            map.fitBounds(markerBounds);
          });
        })
      });
    }
  },
  destroyed() {
    this.$store.dispatch('CLEAR_SHIPMENT');
    this.$store.dispatch('CLEAR_PARCEL_TYPES');
  },
  watch: {
    '$route' () {
      this.getComponentData()
    },
    observableObject: {
      handler(newVal, oldVal){
        if(this.popupDataIsValid()){
          this.makeCall();
        }
      },
      deep: true
    },
    'moveShipmentToBookedPickupData.pickupDate': {
      handler(newVal, oldVal){
        if(newVal && (newVal !== oldVal)){
          this.getAvailableBookedPickups(newVal);
        }
      },
      deep: true
    },
  },
}
</script>
<style>
.country-options-list {
  right: 0!important;
}
</style>
